// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.print-slide {
  --fs-clarify: #06AED0;
  --fs-ideate: #FF7900;
  --fs-develop: #69BE29;
  --fs-implement: #F44358;
  --fs-dark: #666666;
  --fs-dark-deep: #333333;
  --fs-border: #E5E7EB;
  --fs-bg-alt: #F7F8FA;
  --fs-white: #FFFFFF;
  display: none;
  width: 100%;
  background: var(--fs-white);
  font-family: "Museo Sans 300", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: var(--fs-dark-deep);
  print-color-adjust: exact;
}
.print-slide *, .print-slide *::before, .print-slide *::after {
  box-sizing: border-box;
}
.print-slide__wrapper {
  width: 100%;
  padding: 0 16px;
}
.print-slide__header {
  margin-bottom: 16px;
}
.print-slide__header-accent {
  height: 5px;
  background: linear-gradient(to right, var(--fs-clarify) 25%, var(--fs-ideate) 25%, var(--fs-ideate) 50%, var(--fs-develop) 50%, var(--fs-develop) 75%, var(--fs-implement) 75%);
}
.print-slide__header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0 8px;
  border-bottom: 1px solid var(--fs-border);
}
.print-slide__header-left {
  display: flex;
  flex-direction: column;
}
.print-slide__header-title {
  font-size: 22px;
  font-weight: 700;
  font-family: "Museo Sans 700", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: var(--fs-dark-deep);
  text-transform: capitalize;
  margin: 0;
  line-height: 1.2;
}
.print-slide__header-subtitle {
  font-size: 11px;
  color: var(--fs-dark);
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-top: 2px;
}
.print-slide__header-logo {
  width: 130px;
  flex-shrink: 0;
}
.print-slide__header-logo img {
  width: 100%;
  height: auto;
  display: block;
}
.print-slide__card {
  display: flex;
  align-items: stretch;
  border: 1px solid var(--fs-border);
  border-radius: 6px;
  margin-bottom: 8px;
  background: var(--fs-white);
  page-break-inside: avoid;
  break-inside: avoid;
}
.print-slide__card:nth-child(even) {
  background: var(--fs-bg-alt);
}
.print-slide__card-num {
  flex: 0 0 34px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 12px;
}
.print-slide__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--fs-clarify);
  color: var(--fs-white);
  font-size: 11px;
  font-weight: 700;
  font-family: "Museo Sans 700", "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 1;
  flex-shrink: 0;
}
.print-slide__card-thumb {
  flex: 0 0 228px;
  padding: 9px;
  display: flex;
  align-items: flex-start;
}
.print-slide__card-notes {
  flex: 1 1 0;
  min-width: 0;
  padding: 10px 12px 10px 0;
  border-left: 1px solid var(--fs-border);
}
.print-slide__thumb-viewport {
  width: 210px;
  height: 140px;
  overflow: hidden;
  border-radius: 4px;
  border: 1px solid var(--fs-border);
  background: #EAEDF0;
  flex-shrink: 0;
  position: relative;
}
.print-slide__thumb-inner {
  width: 350px;
  transform: scale(0.6);
  transform-origin: top left;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 6px;
  background-color: #fff;
  color: #6D6E71;
  overflow: hidden;
}
.print-slide__thumb-inner .start-work__popuprow {
  width: 350px;
  min-height: 200px;
  position: relative;
}
.print-slide__thumb-inner .start-work__popuprow > div {
  padding: 10px;
}
.print-slide__thumb-inner .start-work__popuprow--content {
  width: 350px;
  min-height: 200px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  overflow: hidden;
}
.print-slide__thumb-inner .start-work__popuprow--content .title-sm {
  font-weight: 600;
}
.print-slide__thumb-inner .start-work__popuprow--content > * {
  max-width: 100%;
}
.print-slide__thumb-inner ::ng-deep .feedback-wrapper {
  position: relative !important;
  display: block !important;
  transform: none !important;
  left: auto !important;
  top: auto !important;
  width: 100% !important;
  height: auto !important;
  min-height: 200px;
}
.print-slide__thumb-inner .start-work__popuprow--content--head ::ng-deep .feedback-content .title-sm {
  color: #fff;
  font-weight: 600;
  font-size: 19px;
}
.print-slide__thumb-inner .start-work__popuprow--content--bgc {
  background-color: #fff;
  background-size: contain;
}
.print-slide__thumb-inner .start-work__popuprow--content--cong {
  display: flex;
  align-items: center;
}
.print-slide__thumb-inner .start-work__popuprow--content--cong ::ng-deep .feedback-content p, .print-slide__thumb-inner .start-work__popuprow--content--cong ::ng-deep .feedback-content h2 {
  margin: 0;
}
.print-slide__thumb-inner .start-work__popuprow--content--cong ::ng-deep .feedback-content .feedback-test_result {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.print-slide__thumb-inner .start-work__popuprow--content--graph {
  min-height: 280px;
}
.print-slide__thumb-inner .start-work__popuprow--content--graph ::ng-deep .feedback-content .title-sm {
  font-size: 16px;
}
.print-slide__thumb-inner .start-work__popuprow--content--graph ::ng-deep .feedback-content .feedback-test_result {
  max-width: 320px;
  margin: 0 auto;
  text-align: center;
  transform: scale(0.85);
  transform-origin: top center;
}
.print-slide__thumb-inner .start-work__popuprow--content--wsu9 ::ng-deep .feedback-content .feedback-test_result {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.print-slide__thumb-inner .start-work__popuprow--content--cpro ::ng-deep .feedback-content .profile_types {
  margin-inline: auto;
}
.print-slide__thumb-inner .start-work__popuprow--content--cpro ::ng-deep .feedback-content .feedback-test_result {
  text-align: center;
}
.print-slide__thumb-inner .start-work__popuprow--content--wwo ::ng-deep .feedback-content .title-sm {
  margin-bottom: 10px !important;
}
.print-slide__thumb-inner ::ng-deep .feedback-content {
  overflow: hidden;
  max-width: 350px;
}
.print-slide__thumb-inner ::ng-deep .feedback-content .title {
  font-size: 18px;
  margin: 0;
  color: #fff;
}
.print-slide__thumb-inner ::ng-deep .feedback-content .title-sm {
  font-size: 14px;
}
.print-slide__thumb-inner ::ng-deep .feedback-content img {
  max-width: 100%;
  height: auto;
}
.print-slide__thumb-inner ::ng-deep .feedback-content .custom-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;
  max-width: 100%;
}
.print-slide__notes-text {
  font-size: 12px;
  line-height: 1.55;
  color: var(--fs-dark);
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.print-slide__notes-text ::ng-deep p {
  margin: 0 0 5px 0;
}
.print-slide__notes-text ::ng-deep p:last-child {
  margin-bottom: 0;
}
.print-slide__notes-text ::ng-deep ul, .print-slide__notes-text ::ng-deep ol {
  padding-left: 16px;
  margin: 0 0 5px 0;
}
.print-slide__notes-text ::ng-deep li + li {
  margin-top: 2px;
}
.print-slide__notes-text ::ng-deep strong, .print-slide__notes-text ::ng-deep b {
  color: var(--fs-dark-deep);
}
.print-slide__notes-text ::ng-deep span {
  color: inherit !important;
  font-size: inherit !important;
  font-family: inherit !important;
}

@media print {
  ::ng-deep .lmslider {
    display: none !important;
  }
  ::ng-deep .TCWA {
    display: none !important;
  }
  ::ng-deep .lm-an-cards__print {
    display: none !important;
  }
  ::ng-deep .practioner-dash-wrap--ss {
    padding: 0 !important;
  }
  .print-slide {
    display: block !important;
  }
  .print-slide__thumb-inner .start-work__popuprow--content,
  .print-slide__header-accent,
  .print-slide__badge {
    print-color-adjust: exact !important;
  }
  ::ng-deep .start-work__popuprow--content .title {
    margin: 0;
  }
  .print-slide__card {
    page-break-inside: avoid;
    break-inside: avoid;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/learner-maps/dynamic-learner-map/dynamic-card/slideshow-print/slideshow-print.component.scss"],"names":[],"mappings":"AAgBA;EACI,qBAAA;EACA,oBAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EAEA,aAAA;EACA,WAAA;EACA,2BAAA;EACA,6EAAA;EACA,0BAAA;EAEA,yBAAA;AAhBJ;AAkBI;EACI,sBAAA;AAhBR;AAoBI;EACI,WAAA;EACA,eAAA;AAlBR;AAwBI;EACI,mBAAA;AAtBR;AAyBI;EACI,WAAA;EACA,+KAAA;AAvBR;AAkCI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,yCAAA;AAhCR;AAmCI;EACI,aAAA;EACA,sBAAA;AAjCR;AAoCI;EACI,eAAA;EACA,gBAAA;EACA,6EAAA;EACA,0BAAA;EACA,0BAAA;EACA,SAAA;EACA,gBAAA;AAlCR;AAqCI;EACI,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;AAnCR;AAsCI;EACI,YAAA;EACA,cAAA;AApCR;AAsCQ;EACI,WAAA;EACA,YAAA;EACA,cAAA;AApCZ;AA2CI;EACI,aAAA;EACA,oBAAA;EACA,kCAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,wBAAA;EACA,mBAAA;AAzCR;AA2CQ;EACI,4BAAA;AAzCZ;AA8CI;EACI,cAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,iBAAA;AA5CR;AA+CI;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,6EAAA;EACA,cAAA;EACA,cAAA;AA7CR;AAiDI;EACI,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AA/CR;AAmDI;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,uCAAA;AAjDR;AA2DI;EACI,YAhKI;EAiKJ,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAzDR;AA4DI;EACI,YA7KG;EA8KH,qBAAA;EACA,0BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EAGA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AA5DR;AA8DQ;EACI,YA3LD;EA4LC,iBAAA;EACA,kBAAA;AA5DZ;AA8DY;EACI,aAAA;AA5DhB;AAgEQ;EACI,YArMD;EAsMC,iBAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AA9DZ;AAgEY;EACI,gBAAA;AA9DhB;AAkEY;EACI,eAAA;AAhEhB;AAsEQ;EACI,6BAAA;EACA,yBAAA;EACA,0BAAA;EACA,qBAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AApEZ;AAyEY;EACI,WAAA;EACA,gBAAA;EACA,eAAA;AAvEhB;AA2EQ;EACI,sBAAA;EACA,wBAAA;AAzEZ;AA4EQ;EACI,aAAA;EACA,mBAAA;AA1EZ;AA6EgB;EAAQ,SAAA;AA1ExB;AA2EgB;EACI,aAAA;EACA,eAAA;EACA,uBAAA;AAzEpB;AA8EQ;EAEI,iBAAA;AA7EZ;AAgFgB;EACI,eAAA;AA9EpB;AAgFgB;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EAGA,sBAAA;EACA,4BAAA;AAhFpB;AAsFY;EACI,aAAA;EACA,eAAA;EACA,uBAAA;AApFhB;AA0FgB;EAAiB,mBAAA;AAvFjC;AAwFgB;EAAwB,kBAAA;AArFxC;AA2FgB;EACI,8BAAA;AAzFpB;AA+FQ;EACI,gBAAA;EACA,gBA9SD;AAiNX;AA+FY;EACI,eAAA;EACA,SAAA;EACA,WAAA;AA7FhB;AA+FY;EACI,eAAA;AA7FhB;AAiGY;EACI,eAAA;EACA,YAAA;AA/FhB;AAkGY;EACI,aAAA;EACA,qCAAA;EACA,QAAA;EACA,eAAA;AAhGhB;AAwGI;EACI,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;AAtGR;AAyGY;EACI,iBAAA;AAvGhB;AAwGgB;EAAe,gBAAA;AArG/B;AAwGY;EACI,kBAAA;EACA,iBAAA;AAtGhB;AAyGY;EACI,eAAA;AAvGhB;AA0GY;EACI,0BAAA;AAxGhB;AA4GY;EACI,yBAAA;EACA,6BAAA;EACA,+BAAA;AA1GhB;;AAmHA;EAEI;IACI,wBAAA;EAjHN;EAmHE;IACI,wBAAA;EAjHN;EAmHE;IACI,wBAAA;EAjHN;EAmHE;IACI,qBAAA;EAjHN;EAqHE;IACI,yBAAA;EAnHN;EAuHE;;;IAII,oCAAA;EArHN;EAyHE;IACI,SAAA;EAvHN;EA2HE;IACI,wBAAA;IACA,mBAAA;EAzHN;AACF","sourcesContent":["// ═══════════════════════════════════════════════════════════\n// Print Slide Notes — FourSight\n// ═══════════════════════════════════════════════════════════\n// CIG components render at 350px wide (matching the hover popup\n// in dynamic-card.component.scss). We scale them to 60% to\n// produce crisp thumbnails without cropping.\n//\n// Key fix: render area height is NOT constrained — CIG components\n// render at their natural height, and overflow:hidden on the\n// viewport clips cleanly. Graph/score slides use a taller viewport.\n// ═══════════════════════════════════════════════════════════\n\n$render-w: 350px;\n$scale: 0.6;\n$visible-w: $render-w * $scale; // 210px\n\n.print-slide {\n    --fs-clarify:   #06AED0;\n    --fs-ideate:    #FF7900;\n    --fs-develop:   #69BE29;\n    --fs-implement: #F44358;\n    --fs-dark:      #666666;\n    --fs-dark-deep: #333333;\n    --fs-border:    #E5E7EB;\n    --fs-bg-alt:    #F7F8FA;\n    --fs-white:     #FFFFFF;\n\n    display: none;\n    width: 100%;\n    background: var(--fs-white);\n    font-family: \"Museo Sans 300\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    color: var(--fs-dark-deep);\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n\n    *, *::before, *::after {\n        box-sizing: border-box;\n    }\n\n    // ── Wrapper ──\n    &__wrapper {\n        width: 100%;\n        padding: 0 16px;\n    }\n\n    // ══════════════════════════════\n    // Header\n    // ══════════════════════════════\n    &__header {\n        margin-bottom: 16px;\n    }\n\n    &__header-accent {\n        height: 5px;\n        background: linear-gradient(\n            to right,\n            var(--fs-clarify) 25%,\n            var(--fs-ideate) 25%,\n            var(--fs-ideate) 50%,\n            var(--fs-develop) 50%,\n            var(--fs-develop) 75%,\n            var(--fs-implement) 75%\n        );\n    }\n\n    &__header-inner {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 12px 0 8px;\n        border-bottom: 1px solid var(--fs-border);\n    }\n\n    &__header-left {\n        display: flex;\n        flex-direction: column;\n    }\n\n    &__header-title {\n        font-size: 22px;\n        font-weight: 700;\n        font-family: \"Museo Sans 700\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n        color: var(--fs-dark-deep);\n        text-transform: capitalize;\n        margin: 0;\n        line-height: 1.2;\n    }\n\n    &__header-subtitle {\n        font-size: 11px;\n        color: var(--fs-dark);\n        letter-spacing: 0.5px;\n        text-transform: uppercase;\n        margin-top: 2px;\n    }\n\n    &__header-logo {\n        width: 130px;\n        flex-shrink: 0;\n\n        img {\n            width: 100%;\n            height: auto;\n            display: block;\n        }\n    }\n\n    // ══════════════════════════════\n    // Card Row\n    // ══════════════════════════════\n    &__card {\n        display: flex;\n        align-items: stretch;\n        border: 1px solid var(--fs-border);\n        border-radius: 6px;\n        margin-bottom: 8px;\n        background: var(--fs-white);\n        page-break-inside: avoid;\n        break-inside: avoid;\n\n        &:nth-child(even) {\n            background: var(--fs-bg-alt);\n        }\n    }\n\n    // ── Slide Number ──\n    &__card-num {\n        flex: 0 0 34px;\n        display: flex;\n        align-items: flex-start;\n        justify-content: center;\n        padding-top: 12px;\n    }\n\n    &__badge {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        width: 24px;\n        height: 24px;\n        border-radius: 50%;\n        background: var(--fs-clarify);\n        color: var(--fs-white);\n        font-size: 11px;\n        font-weight: 700;\n        font-family: \"Museo Sans 700\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n        line-height: 1;\n        flex-shrink: 0;\n    }\n\n    // ── Thumbnail Column ──\n    &__card-thumb {\n        flex: 0 0 #{$visible-w + 18px}; // 210 + padding\n        padding: 9px;\n        display: flex;\n        align-items: flex-start;\n    }\n\n    // ── Notes Column ──\n    &__card-notes {\n        flex: 1 1 0;\n        min-width: 0;\n        padding: 10px 12px 10px 0;\n        border-left: 1px solid var(--fs-border);\n    }\n\n    // ══════════════════════════════\n    // Thumbnail: viewport + scale\n    // ══════════════════════════════\n    // Viewport = visible window, clips overflow.\n    // Inner = 350px wide render area, scale(0.6) → 210px visible.\n    // Height is auto — CIG components render at natural height,\n    // viewport clips the excess cleanly.\n    &__thumb-viewport {\n        width: $visible-w;\n        height: 140px; // default: 233px render × 0.6\n        overflow: hidden;\n        border-radius: 4px;\n        border: 1px solid var(--fs-border);\n        background: #EAEDF0;\n        flex-shrink: 0;\n        position: relative;\n    }\n\n    &__thumb-inner {\n        width: $render-w;\n        transform: scale(#{$scale});\n        transform-origin: top left;\n        position: absolute;\n        top: 0;\n        left: 0;\n\n        // Replicate the popup container from dynamic-card.component.scss\n        border-radius: 6px;\n        background-color: #fff;\n        color: #6D6E71;\n        overflow: hidden;\n\n        .start-work__popuprow {\n            width: $render-w;\n            min-height: 200px;\n            position: relative;\n\n            & > div {\n                padding: 10px;\n            }\n        }\n\n        .start-work__popuprow--content {\n            width: $render-w;\n            min-height: 200px;\n            background-position: center;\n            background-repeat: no-repeat;\n            background-size: cover;\n            position: relative;\n            overflow: hidden;\n\n            .title-sm {\n                font-weight: 600;\n            }\n\n            // Ensure all child elements stay within bounds\n            > * {\n                max-width: 100%;\n            }\n        }\n\n        // Force feedback-wrapper to render inline (not absolute-centered\n        // as in the owl-carousel slideshow context)\n        ::ng-deep .feedback-wrapper {\n            position: relative !important;\n            display: block !important;\n            transform: none !important;\n            left: auto !important;\n            top: auto !important;\n            width: 100% !important;\n            height: auto !important;\n            min-height: 200px;\n        }\n\n        // ── Popup variant styles (from dynamic-card.component.scss) ──\n        .start-work__popuprow--content--head {\n            ::ng-deep .feedback-content .title-sm {\n                color: #fff;\n                font-weight: 600;\n                font-size: 19px;\n            }\n        }\n\n        .start-work__popuprow--content--bgc {\n            background-color: #fff;\n            background-size: contain;\n        }\n\n        .start-work__popuprow--content--cong {\n            display: flex;\n            align-items: center;\n\n            ::ng-deep .feedback-content {\n                p, h2 { margin: 0; }\n                .feedback-test_result {\n                    display: flex;\n                    flex-wrap: wrap;\n                    justify-content: center;\n                }\n            }\n        }\n\n        .start-work__popuprow--content--graph {\n            // Graph slides need more room\n            min-height: 280px;\n\n            ::ng-deep .feedback-content {\n                .title-sm {\n                    font-size: 16px;\n                }\n                .feedback-test_result {\n                    max-width: 320px;\n                    margin: 0 auto;\n                    text-align: center;\n\n                    // Scale down graph internals to fit\n                    transform: scale(0.85);\n                    transform-origin: top center;\n                }\n            }\n        }\n\n        .start-work__popuprow--content--wsu9 {\n            ::ng-deep .feedback-content .feedback-test_result {\n                display: flex;\n                flex-wrap: wrap;\n                justify-content: center;\n            }\n        }\n\n        .start-work__popuprow--content--cpro {\n            ::ng-deep .feedback-content {\n                .profile_types { margin-inline: auto; }\n                .feedback-test_result { text-align: center; }\n            }\n        }\n\n        .start-work__popuprow--content--wwo {\n            ::ng-deep .feedback-content {\n                .title-sm {\n                    margin-bottom: 10px !important;\n                }\n            }\n        }\n\n        // General feedback-content overrides for print thumbnails\n        ::ng-deep .feedback-content {\n            overflow: hidden;\n            max-width: $render-w;\n\n            .title {\n                font-size: 18px;\n                margin: 0;\n                color: #fff;\n            }\n            .title-sm {\n                font-size: 14px;\n            }\n\n            // Contain any absolutely positioned children\n            img {\n                max-width: 100%;\n                height: auto;\n            }\n\n            .custom-row {\n                display: grid;\n                grid-template-columns: repeat(4, 1fr);\n                gap: 4px;\n                max-width: 100%;\n            }\n        }\n    }\n\n    // ══════════════════════════════\n    // Notes Text\n    // ══════════════════════════════\n    &__notes-text {\n        font-size: 12px;\n        line-height: 1.55;\n        color: var(--fs-dark);\n        word-wrap: break-word;\n        overflow-wrap: break-word;\n\n        ::ng-deep {\n            p {\n                margin: 0 0 5px 0;\n                &:last-child { margin-bottom: 0; }\n            }\n\n            ul, ol {\n                padding-left: 16px;\n                margin: 0 0 5px 0;\n            }\n\n            li + li {\n                margin-top: 2px;\n            }\n\n            strong, b {\n                color: var(--fs-dark-deep);\n            }\n\n            // Reset inline style overrides from rich text editor\n            span {\n                color: inherit !important;\n                font-size: inherit !important;\n                font-family: inherit !important;\n            }\n        }\n    }\n}\n\n// ═══════════════════════════════════════════════════════════\n// @MEDIA PRINT\n// ═══════════════════════════════════════════════════════════\n@media print {\n    // Hide on-screen slideshow UI\n    ::ng-deep .lmslider {\n        display: none !important;\n    }\n    ::ng-deep .TCWA {\n        display: none !important;\n    }\n    ::ng-deep .lm-an-cards__print {\n        display: none !important;\n    }\n    ::ng-deep .practioner-dash-wrap--ss {\n        padding: 0 !important;\n    }\n\n    // Show print layout\n    .print-slide {\n        display: block !important;\n    }\n\n    // Preserve background images & brand colors in print\n    .print-slide__thumb-inner .start-work__popuprow--content,\n    .print-slide__header-accent,\n    .print-slide__badge {\n        -webkit-print-color-adjust: exact !important;\n        print-color-adjust: exact !important;\n    }\n\n    // Title margin\n    ::ng-deep .start-work__popuprow--content .title {\n        margin: 0;\n    }\n\n    // Page break control\n    .print-slide__card {\n        page-break-inside: avoid;\n        break-inside: avoid;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
